import { Grid, useTheme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ToolIconButton } from "../../ToolIconButton";
import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
import { ArrowBack } from "@mui/icons-material";
import { isDesktop, isMobile } from "react-device-detect";
import { getInvertColor } from "utils/themeUtils";

type ToolBatType = {
	handleCreateNote: any;
	handleDeleteNote: any;
	allowedEdit: boolean;
	handleEditNoteFeature: any;
};

const ToolBar: React.FC<ToolBatType> = ({ handleCreateNote, handleDeleteNote, allowedEdit, handleEditNoteFeature }) => {
	const classes = useStyles();
	const theme = useTheme();
	return (
		<>
			{allowedEdit && isMobile ? (
				<Grid
					item
					style={{
						position: "absolute",
						left: theme.breakpoints.values.smallMobile >= window.innerWidth ? 15 : 20,
					}}
				>
					<ToolIconButton onClick={handleEditNoteFeature}>
						<ArrowBack fontSize="small" className={`${classes.button} ${classes.backwards} `} />
					</ToolIconButton>
				</Grid>
			) : (
				<Grid item>
					<ToolIconButton onClick={handleDeleteNote}>
						<DeleteIcon fontSize="small" className={classes.button} />
					</ToolIconButton>
					{isDesktop && (
						<ToolIconButton onClick={handleCreateNote}>
							<CreateIcon fontSize="small" className={classes.button} />
						</ToolIconButton>
					)}
				</Grid>
			)}
		</>
	);
};

export default ToolBar;

const useStyles = makeStyles((theme) => ({
	button: {
		fill: getInvertColor(theme.palette.primary.main)
	},
	backwards: {
		fontSize: "1.75rem",
		marginLeft: -10,
	},
}));
